import { useState, useEffect } from "react";

const LOUIS_IMAGE = "https://customer-assets.emergentagent.com/job_socials-automate/artifacts/dp64o5ky_ChatGPT%20Image%2019%20janv.%202026%2C%2021_40_24.png";

export default function LouisAvatar({ size = 40, isThinking = false, className = "" }) {
  const [bounce, setBounce] = useState(false);
  const [wave, setWave] = useState(false);

  // Animation de rebond aléatoire
  useEffect(() => {
    const bounceInterval = setInterval(() => {
      setBounce(true);
      setTimeout(() => setBounce(false), 500);
    }, 5000 + Math.random() * 3000);

    return () => clearInterval(bounceInterval);
  }, []);

  // Animation de salut occasionnelle
  useEffect(() => {
    const waveInterval = setInterval(() => {
      setWave(true);
      setTimeout(() => setWave(false), 1000);
    }, 10000 + Math.random() * 5000);

    return () => clearInterval(waveInterval);
  }, []);

  return (
    <div 
      className={`relative ${className}`}
      style={{ 
        width: size, 
        height: size,
      }}
    >
      {/* Container avec animations */}
      <div
        className="w-full h-full rounded-full overflow-hidden border-2 border-primary/30 shadow-lg"
        style={{
          animation: isThinking 
            ? 'thinking 1s ease-in-out infinite' 
            : bounce 
              ? 'bounce-small 0.5s ease-in-out'
              : wave
                ? 'wave 1s ease-in-out'
                : 'float 3s ease-in-out infinite',
          transformOrigin: 'center bottom'
        }}
      >
        {/* Image de Louis */}
        <img
          src={LOUIS_IMAGE}
          alt="Louis - Assistant IA"
          className="w-full h-full object-cover object-top"
          style={{
            transform: 'scale(1.3) translateY(5%)',
          }}
        />
      </div>

      {/* Indicateur de réflexion */}
      {isThinking && (
        <div className="absolute -top-1 -right-1 flex gap-0.5">
          <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
          <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
          <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
        </div>
      )}

      {/* Styles d'animation */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-3px); }
        }
        
        @keyframes bounce-small {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(-8px) scale(1.05); }
        }
        
        @keyframes wave {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-5deg); }
          75% { transform: rotate(5deg); }
        }
        
        @keyframes thinking {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.08); }
        }
      `}</style>
    </div>
  );
}
